"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledShoppingCartOutlined = exports.IconClasses = exports.StyledBadge = void 0;
const Badge_1 = __importStar(require("@mui/material/Badge"));
const styles_1 = require("@mui/material/styles");
const ShoppingCartOutlined_1 = __importDefault(require("../icon/svgs/ShoppingCartOutlined"));
exports.StyledBadge = (0, styles_1.styled)(Badge_1.default)(({ theme }) => ({
    [`.${Badge_1.badgeClasses.badge}`]: {
        [theme.breakpoints.down("md")]: {
            width: "15px",
            minWidth: "15px",
            height: "15px",
            minHeight: "15px"
        },
        width: "19px",
        minWidth: "19px",
        height: "19px",
        minHeight: "19px",
        margin: "3px 3px 0px 0px",
        top: "0px",
        right: "0px",
        left: "2px",
        bottom: "0px",
        borderRadius: "50%",
        border: `1px solid ${theme.palette.background.paper}`,
        cursor: "default"
    }
}));
const PREFIX = "IconClasses";
exports.IconClasses = {
    white: `${PREFIX}-white`,
    inter: `${PREFIX}-inter`
};
exports.StyledShoppingCartOutlined = (0, styles_1.styled)(ShoppingCartOutlined_1.default)({
    height: "24px",
    width: "24px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Nob3BwaW5nLWNhcnQtYnV0dG9uL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZEQUEwRDtBQUMxRCxpREFBOEM7QUFDOUMsNkZBQXFFO0FBRXhELFFBQUEsV0FBVyxHQUFHLElBQUEsZUFBTSxFQUFDLGVBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN2RCxDQUFDLElBQUksb0JBQVksQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQzFCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM5QixLQUFLLEVBQUUsTUFBTTtZQUNiLFFBQVEsRUFBRSxNQUFNO1lBQ2hCLE1BQU0sRUFBRSxNQUFNO1lBQ2QsU0FBUyxFQUFFLE1BQU07U0FDbEI7UUFDRCxLQUFLLEVBQUUsTUFBTTtRQUNiLFFBQVEsRUFBRSxNQUFNO1FBQ2hCLE1BQU0sRUFBRSxNQUFNO1FBQ2QsU0FBUyxFQUFFLE1BQU07UUFDakIsTUFBTSxFQUFFLGlCQUFpQjtRQUN6QixHQUFHLEVBQUUsS0FBSztRQUNWLEtBQUssRUFBRSxLQUFLO1FBQ1osSUFBSSxFQUFFLEtBQUs7UUFDWCxNQUFNLEVBQUUsS0FBSztRQUNiLFlBQVksRUFBRSxLQUFLO1FBQ25CLE1BQU0sRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDLEtBQUssRUFBRTtRQUNyRCxNQUFNLEVBQUUsU0FBUztLQUNsQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRUosTUFBTSxNQUFNLEdBQUcsYUFBYSxDQUFDO0FBQ2hCLFFBQUEsV0FBVyxHQUFHO0lBQ3pCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtJQUN4QixLQUFLLEVBQUUsR0FBRyxNQUFNLFFBQVE7Q0FDekIsQ0FBQztBQUVXLFFBQUEsMEJBQTBCLEdBQUcsSUFBQSxlQUFNLEVBQUMsOEJBQW9CLENBQUMsQ0FBQztJQUNyRSxNQUFNLEVBQUUsTUFBTTtJQUNkLEtBQUssRUFBRSxNQUFNO0NBQ2QsQ0FBQyxDQUFDIn0=